import { Reducer } from 'redux';
import { ActionType, getType } from 'typesafe-actions';
import { IGameState } from '../../Game/IGameState';
import { helperFriendRequest } from './Action/HelperFriendRequest';
import { helperFriendResponse } from './Action/HelperFriendResponse';
import { HelperFriendActions } from './HelperFriendActions';

export const HelperFriendRequestReducer: Reducer<IGameState> = (
    state: IGameState,
    action: ActionType<typeof HelperFriendActions>
): IGameState => {
    if (action.type === getType(HelperFriendActions.helperFriendRequest)) {
        return helperFriendRequest(state, action.payload);
    }

    return state;
};

export const HelperFriendResponseReducer: Reducer<IGameState> = (
    state: IGameState,
    action: ActionType<typeof HelperFriendActions>
): IGameState => {
    if (action.type === getType(HelperFriendActions.helperFriendResponse)) {
        return helperFriendResponse(
            state,
            action.payload.success,
            action.payload.friendId
        );
    }

    return state;
};
